<template>
  <div>
    <a-alert v-if="iconLoading" :message="msg" :type="typ" />
    <b-form @submit="onSubmit">
      <a-button-group>
        <a-button :disabled="counts>19" @click="add">
          <b-icon style="margin-right: 0.3rem;" scale="1.1" icon="person-plus" variant="muted"></b-icon>新增帳號           
          <span
            class="badge badge-info"
            style="margin-left:0.5rem;font-size: 0.7rem;"
            v-text="counts"
          />
        </a-button>
        <a-button type="primary" :disabled="checkitem" @click="onSubmit">
          <b-icon style="margin-right: 0.3rem;" scale="1.1" icon="caret-right-square" variant="muted"></b-icon>
          確認送出
        </a-button>
      </a-button-group>
      <span
        v-if="textFields.length>0"
        style="margin-left:1rem;font-size: 14px;"
        class="badge badge-pill badge-success"
        v-text="' 隨機密碼 : '+ DayPassWord"
      />
      <p></p>

      <div v-for="(textField, i) in textFields" :key="i">
        <div class="form-container p-2 mb-3 border border-light rounded" >
          <!-- 表單標題與操作區 -->
          <div class="d-flex flex-wrap align-items-center mb-2">
            <h6 class="mr-2 mb-2">
              <span v-if="textField.value3 || textField.value4 || textField.value5 || textField.value6" 
                    class="badge badge-danger">資料尚未輸入完整</span>
            </h6>
            <div class="ml-auto">
              <a-button @click="remove(i)" type="link" size="small">
                <i class="fas fa-trash-alt mr-1"></i>刪除
              </a-button>
              <a-switch
                checked-children="加入"
                un-checked-children="不加入"
                @change="onChange(i,textField.checked)"
                :checked="textField.checked"
                default-checked
              />
              <span class="ml-1">(會員)</span>
            </div>
          </div>

          <!-- 表單欄位 - 響應式布局 -->
          <div class="row g-2" >
            <!-- 帳號欄位 -->
            <div class="col-12 col-md-6 col-lg-4 mb-2">
              <b-form-group
                id="input-group-1"
                :description="textField.value4? '該帳號已存在, 請使用其它帳號':''"
                :state="!textField.errorMsg"
                label-for="input-1"
              >
                <label for="input-group-1" class="d-flex align-items-center">
                  <code>*</code>登入帳號:
                </label>
                <b-form-input
                  id="input-1"
                  v-model="textField.account"
                  @blur="checkAccount(i)"
                  type="text"
                  autocomplete="off"
                  placeholder="請輸入手機號碼作為帳號"
                  :state="textField.account ? (textField.errorMsg ? false : true) : null"
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <!-- 顯示名稱欄位 -->
            <div class="col-12 col-md-6 col-lg-4 mb-2">
              <b-form-group id="input-group-2" label-for="input-2">
                <label for="input-group-2">
                  <code>*</code>顯示名稱:
                </label>
                <b-form-input
                  id="input-2"
                  v-model="textField.username"
                  @blur="checkAddress(i)"
                  type="text"
                  placeholder="輸入名稱"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <!-- 聯絡電話欄位 -->
            <div class="col-12 col-md-6 col-lg-4 mb-2">
              <b-form-group id="input-group-4" label-for="input-4">
                <label for="input-group-4">
                  <code>*</code>聯絡電話:
                </label>
                <b-form-input
                  id="input-4"
                  v-model="textField.phone"
                  @blur="checkAddress(i)"                  
                  type="number"
                  placeholder="輸入電話"
                  autocomplete="off"
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <!-- 地址欄位 - 佔據較寬空間 -->
            <div class="col-12 col-lg-8 mb-2">
              <b-form-group id="input-group-3" label-for="input-3">
                <label for="input-group-3" class="d-flex align-items-center">
                  <code>*</code>地址:
                  <a-button @click="getAddress(i)" type="link" size="small" class="ml-1">(選取地址)</a-button>
                </label>
                <b-form-input
                  id="input-3"
                  v-model="textField.address"
                  type="text"
                  placeholder="請選取地址"
                  autocomplete="off"
                  readonly
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <!-- 巷弄路名欄位 -->
            <div class="col-12 col-md-6 col-lg-4 mb-2">
              <b-form-group id="input-group-alley" label-for="input-alley">
                <label for="input-group-alley">
                  巷弄路名 (選填):
                </label>
                <b-form-input
                  id="input-alley"
                  v-model="textField.alley"
                  @blur="updateFullAddress(i)"
                  type="text"
                  placeholder="請輸入巷弄路名 (選填)"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
            </div>

        <div class="col-12 col-md-6 col-lg-4 mb-2">
            <b-form-group id="input-group-birth" label-for="input-birth">
              <label for="input-group-birth">
                <code>*</code>
                生日:
              </label>
              <b-form-input
                id="input-birth"
                v-model="textField.birth"
                @blur="checkAddress(i)"
                type="date"
                placeholder="請輸入生日 (選填)"
                autocomplete="off"
                required
              ></b-form-input>
            </b-form-group>  
        </div>

         <div class="col-12 col-md-6 col-lg-4 mb-2">
            <b-form-group id="input-group-11" description label-for="input-sex">
              <label class="d-flex align-items-left" for="input-sex">
                <code>*</code>
                <span >輸入性別 (男/女)</span>
              </label>
              <b-form-select
                id="input-sex"
                v-model="textField.sex"
                @blur="checkAddress(i)"
                :options="[{ value: 'male', text: '男' }, { value: 'female', text: '女' }, { value: 'other', text: '其它' }]"
                placeholder="請選擇性別"
                required
              ></b-form-select>
            </b-form-group>  
          </div>
          

          </div>

          <!-- 確認按鈕 - 置於表單底部 -->
          <div class="d-flex justify-content-end">
            <b-button @click="checkAddress(i)" variant="primary" class="px-4">
              <i class="fas fa-check mr-1"></i>確認資料
            </b-button>
          </div>
        </div>
      </div>
    </b-form>
    <b-modal
      ref="my-address"
      id="modal-2"
      title="地址選取"
      @hide="onHide"
      centered
      hide-footer
      hide-header
    >
      <div class="text-right">
        <a-button @click="closeModal()" type="link" size="small">(關閉)</a-button>
        <Addresscom @toaddress="toaddress" />
      </div>
    </b-modal>
    <b-modal
      ref="my-loading"
      id="modal-2"
      title="Loading"
      @hide="onHide"
      centered
      hide-footer
      hide-header
    >
      <div class="text-center">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
        <strong>Loading....</strong>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { userService } from "../../../_services/";
import Addresscom from "../../../components/Addresslist.vue";
import * as moment from "moment/moment";
const postData = params => {
  return userService.registlist(params);
};

export default {
  name: "Inputmenber",
  components: {
    Addresscom
  },
  data() {
    return {
      textFields: [], //模板連結
      result: null,
      iconLoading: false,
      counts: 0,
      index: null,
      msg: "",
      DayPassWord: this.getdate(),
      typ: "success"
    };
  },
  mounted() {},
  computed: {
    ...mapState("account", ["status", "user"]),
    ...mapState("makeorg", ["datas", "defaultval"]),
    checkitem() {
      let rs = true;
      let count = 0;
      for (let i in this.textFields) {
        if (
          this.textFields[i].value6 == true ||
          this.textFields[i].value5 == true ||
          this.textFields[i].value4 == true ||
          this.textFields[i].value3 == true
        ) {
          count += 1;
        }
      }
      if (count == 0 && this.textFields.length > 0) {
        rs = false;
      }
      return rs;
    }
  },

  methods: {
    add() {
      this.counts += 1;
      this.textFields.push({
        account: "",
        address: "",
        username: "",
        phone:"",
        sex:"",
        birth:"",
        value3: true,
        value4: false,
        value5: true,
        value6: true, 
        value7: true,
        value8: true,       
        checked: true,
        citys : "",
        villages : "",
        towns :"",
        alley: "", // 新增巷弄路名字段
        errorMsg: "", // 新增欄位錯誤訊息
      });
    },
    checkName(i) {
      if (this.textFields[i] != undefined) {
        return this.textFields[i].account.length > 1 ? true : false;
      }
      return false;
    },
    remove(index) {
      //移除連結
      this.counts -= 1;
      this.textFields.splice(index, 1);
    },
    getAddress(i) {
      this.index = i;
      this.$refs["my-address"].show();
    },
    toaddress(val,city,village,town) {
      this.textFields[this.index].address = val;
      this.textFields[this.index].citys = city;
      this.textFields[this.index].villages = village;
      this.textFields[this.index].towns = town;
      // 选择地址后立即更新完整地址
      this.updateFullAddress(this.index);         
    },   

    onChange(i, checked) {
      this.textFields[i].checked = !checked;
    },
    getdate(val) {
      return this.makeid(3) + moment(val).format("DDHHmm");
    },

    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    async checkAccount(i) {
      // 獲取當前欄位
      const field = this.textFields[i];
      
      // 清理帳號值
      field.account = field.account ? field.account.toString().trim() : "";
      field.errorMsg = ""; // 重置错误信息
      // 檢查帳號是否為空
      if (!field.account) {
        field.errorMsg = "請輸入手機號作為帳號";
        field.value4 = false;
        return;
      }
      // 基本驗證
      const hasChinese = /[\u4E00-\u9FA5]/.test(field.account);
      if (hasChinese) {
        field.errorMsg = "帳號不能包含中文";
        field.value4 = false;
        return;
      }

      /*const taiwanMobilePattern = /^09\d{8}$/;
      
      if (!field.account) {
        field.errorMsg = "請輸入手機號作為帳號";
        field.value4 = false;
        return;
      }
      

      
      if (!taiwanMobilePattern.test(field.account)) {
        field.errorMsg = "帳號必須是09開頭的10位手機號";
        field.value4 = false;
        return;
      }*/
      
      // 檢查同一批次中是否有重複帳號
      const duplicateCount = this.textFields.filter(el => 
        el !== field && el.account.toLowerCase() === field.account.toLowerCase()
      ).length;
      
      if (duplicateCount > 0) {
        field.errorMsg = "此帳號已在本次清單中重複";
        field.value4 = false;
        return;
      }

      // 設置加載狀態
      this.iconLoading = true;

      try {
        // 呼叫API驗證帳號
        const response = await userService.checkAcct(field.account);
        // 根據API返回設置驗證狀態 (verify=true 表示可使用，反之)
        field.value4 = response.data.verify;
        
        if (field.value4) {
          field.errorMsg = "此帳號已存在，請使用其他帳號";
        }else {
          // 验证通过，清除错误消息
          field.errorMsg = "";
        }
        
        // 更新其他驗證狀態
        this.updateValidationState(i);
      } catch (error) {
        console.error("驗證帳號時出錯:", error);
        field.value4 = false;
        field.errorMsg = "驗證帳號時出錯，請稍後再試";
      } finally {
        this.iconLoading = false;
      }
    },

    // 更新完整地址（组合地址和巷弄路名）
    updateFullAddress(i) {
      const field = this.textFields[i];
      
      // 如果有填写巷弄路名，则将其添加到地址后面
      if (field.alley && field.address) {
        const baseAddress = field.address.split('巷')[0].split('弄')[0]; // 移除之前可能已经添加的巷弄信息
        field.fullAddress = baseAddress + (field.alley ? field.alley : '');
      } else {
        field.fullAddress = field.address; // 如果没有巷弄，使用原地址
      }
      
      // 执行地址验证
      this.checkAddress(i);
    },    

    // 輔助方法，統一更新驗證狀態
    updateValidationState(i) {
      const field = this.textFields[i];
      const isComplete = 
        field.account.length > 0 &&
        field.address.length > 0 &&
        field.username.length > 0 &&
        field.phone.length > 0 &&
        field.birth.length > 0 &&
        field.sex.length > 0

      // 所有欄位已填寫且帳號驗證通過
      const isValid = isComplete && !field.value4;
      
      field.value3 = !isValid;
      field.value5 = !isValid;
      field.value6 = !isValid;
      field.value7 = !isValid;
      field.value8 = !isValid;
    },    
    checkAddress(i) {
      this.textFields[i].account.length > 0 &&
      this.textFields[i].address.length > 0 &&
      this.textFields[i].username.length > 0 &&
      this.textFields[i].phone.length > 0 &&
      this.textFields[i].birth.length > 0 &&
      this.textFields[i].sex.length > 0
        ? this.textFields[i].value4 == true && this.textFields[i].value5 == true && this.textFields[i].value6 == true && this.textFields[i].value7  == true && this.textFields[i].value8 == true
          ? ((this.textFields[i].value3 = true),
            (this.textFields[i].value5 = true),
            (this.textFields[i].value6 = true),
            (this.textFields[i].value7 = true),
            (this.textFields[i].value8 = true))
          : ((this.textFields[i].value3 = false),
            (this.textFields[i].value5 = false),
            (this.textFields[i].value6 = false),
            (this.textFields[i].value7 = false),
            (this.textFields[i].value8 = false))
        : ((this.textFields[i].value3 = true),
          (this.textFields[i].value5 = true),
          (this.textFields[i].value6 = true),
          (this.textFields[i].value7 = true),
          (this.textFields[i].value8 = true));
    },

    formatDateForDisplay(date) {
      if (!date) return '';
      // 確保日期格式為 yyyy-mm-dd
      return moment(date).format('YYYY-MM-DD');
    },
 

    async onSubmit(event) {
      event.preventDefault();
      this.$refs["my-loading"].show();
      this.iconLoading = true;
      let datas = [];
      for (let obj of this.textFields) {
        let tmp1 = obj.account;
        let tmp2 = obj.address;
        let tmp3 = obj.username;
        let tmp4 = obj.phone;
        let tmp5 = obj.citys;
        let tmp6 = obj.villages;
        let tmp7 = obj.towns
        let tmp8 = obj.alley || ''; // 获取巷弄路名

        // 组合完整地址
        const fullAddress = obj.alley ? `${tmp2}${tmp8}` : tmp2;        

        datas.push({
          account: tmp1.toString().trim(), //帳號
          address: fullAddress.toString().trim(), //地址
          username: tmp3.toString().trim(), //顯示名稱
          phone: tmp4.toString().trim(), //連絡電話
          birth: this.formatDateForDisplay(obj.birth) || "", // 添加生日
          sex: obj.sex?.toString().trim() || "", // 添加性別
          citys: tmp5.toString().trim(),
          villages: tmp6.toString().trim(),
          towns: tmp7.toString().trim(),
          checked: obj.checked, //確認資料狀態
          oid: this.defaultval.id, //隸屬組織ID
          password: this.DayPassWord //使用者密碼
        });
      }
      if (datas.length > 0) {
        postData(datas).then(({ data }) => {
          let code = data.code;
          if (code == 200) {
            this.$refs["my-loading"].hide();
            this.textFields = [];
            this.counts = 0;
            this.typ = "success";
            this.msg = "新增資料成功";
            setTimeout(() => {
              this.iconLoading = false;
            }, 1000);

          } else {
            this.$refs["my-loading"].hide();
            this.typ = "danger";
            this.msg = "新增資料失敗";
            setTimeout(() => {
              this.iconLoading = false;
            }, 1000);

          }
        });
      }
    },

    onHide(evt) {
      if (evt.trigger === "backdrop") {
        evt.preventDefault();
      }
    },
    closeModal() {
      this.$refs["my-address"].hide();
    }
  }
};
</script>
<style scoped>
/* 添加自定義樣式來減少間距 */
.form-container {
  margin-bottom: 1rem !important; /* 覆蓋 mb-3 的 1.5rem */
  margin-top: -0.5rem; /* 增加上邊距 */
}

.form-container label {
  margin-bottom: 0.25rem; /* 減少標籤的下邊距 */
  margin-top: -0.5rem; /* 增加上邊距 */
}

.form-group {
  margin-bottom: 0.5rem; /* 減少表單組的下邊距 */
  margin-top: -0.5rem; /* 增加上邊距 */
}

/* 如果使用 Bootstrap 5，可以使用 g-2 類；如果是 Bootstrap 4，需要這個自定義樣式 */
.row > [class*="col-"] {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

}
</style>